// @ts-nocheck
/* eslint-disable */
export const dottedIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12"><circle cx="6" cy="6" r="6" fill="currentColor"/><circle cx="6" cy="6" r="4" fill="currentColor"/></svg>`,
    name: 'dotted' as const
};